export const TAB_MAP = {
  terminalView: 'terminalView',
  policyView: 'policyView',
}
